import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {Color} from '$constants/style';

import FrontdeskButton from '~/components/FrontdeskButton';

interface CustomDialogProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  headerIcon?: React.ReactNode;
  children: React.ReactNode;
  onPrimaryClick: () => void;
  primaryButtonTitle: string;
  isPrimaryDisabled?: boolean;
  isPrimaryVisible?: boolean;
  width?: string | number;
  className?: string;
  secondaryButtonTitle?: string;
  isSecondaryVisible?: boolean;
  onSecondaryClick?: () => void;
}

// This is a Generic Customizable Dialog component but for now using it for pricing list feature only,
// if needed in future we can use it for other features as well and change its name
const PricingListCommonWrapperModalComponent: React.FC<CustomDialogProps> = ({
  isOpen,
  onClose,
  title,
  headerIcon,
  children,
  onPrimaryClick,
  primaryButtonTitle,
  isPrimaryDisabled = false,
  isPrimaryVisible = true,
  width = '600px',
  className = '',
  secondaryButtonTitle = 'Cancel',
  isSecondaryVisible = false,
  onSecondaryClick = onClose,
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullWidth
      maxWidth={false}
      PaperProps={{
        style: {
          width: typeof width === 'number' ? `${width}px` : width,
          height: '90vh',
          overflowY: 'auto',
          borderRadius: '1rem',
        },
        className: `bg-white p-6 ${className}`,
      }}
    >
      <Box className="flex items-start justify-between mb-6">
        <Box className="flex flex-col items-start gap-2">
          {headerIcon && (
            <div className="icon-container font-extrabold">{headerIcon}</div>
          )}
          <Typography variant="h5" className="font-semibold text-2xl mt-2">
            {title}
          </Typography>
        </Box>
        <IconButton onClick={onClose} className="!p-2">
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogContent sx={{padding: 0}}>{children}</DialogContent>

      <DialogActions className="px-6 pb-4 flex justify-end gap-3">
        {isSecondaryVisible && (
          <button
            type="button"
            onClick={onSecondaryClick}
            className={`border border-[${Color.TextPrimary}26] text-red-500 bg-transparent rounded-md px-4 py-2 text-sm hover:bg-gray-100`}
          >
            {secondaryButtonTitle}
          </button>
        )}

        {isPrimaryVisible && (
          <FrontdeskButton
            title={primaryButtonTitle}
            onClick={onPrimaryClick}
            disabled={isPrimaryDisabled}
            className="min-w-[120px]"
          />
        )}
      </DialogActions>
    </Dialog>
  );
};

export default PricingListCommonWrapperModalComponent;
